<!-- Hub Settings — auth/session ops on dashboard.* only (not paper/live sidebars). -->
<script>
  import { onMount } from 'svelte'
  import { link } from '../lib/historyNav.js'
  import { checkAuth, logout, replace } from '../api.js'
  import { authUser } from '../stores.js'
  import ThemeToggle from '../components/ThemeToggle.svelte'
  import OfflineBanner from '../components/OfflineBanner.svelte'
  import Sessions from './dashboard/Sessions.svelte'

  onMount(async () => {
    const a = await checkAuth()
    if (!a.ok) {
      replace('/login?next=' + encodeURIComponent('/hub/settings'))
      return
    }
    authUser.set(a.user)
  })
</script>

<OfflineBanner />

<svelte:head>
  <title>Настройки — Lunes Crypto</title>
</svelte:head>

<div class="pm-atmosphere" aria-hidden="true"><div class="pm-atmosphere__grain"></div></div>

<div class="hub-set">
  <header class="hub-set__head">
    <div>
      <a class="hub-set__back" href="/hub" use:link>← Хаб</a>
      <p class="pm-eyebrow">lunes</p>
      <h1 class="hub-set__title">Настройки</h1>
      {#if $authUser}
        <p class="pm-meta">{$authUser}</p>
      {/if}
    </div>
    <div class="hub-set__tools">
      <ThemeToggle variant="nav" />
      <button type="button" class="pm-btn pm-btn--ghost" on:click={() => logout()}>Выйти</button>
    </div>
  </header>

  <nav class="hub-set__nav" aria-label="Настройки">
    <span class="hub-set__nav-item is-active">Сессии</span>
  </nav>

  <div class="hub-set__body">
    <Sessions />
  </div>
</div>

<style>
  .hub-set {
    position: relative;
    z-index: 1;
    max-width: 42rem;
    margin: 0 auto;
    padding: clamp(1.5rem, 4vw, 2.75rem) clamp(1.1rem, 3vw, 1.75rem) 3rem;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    box-sizing: border-box;
  }
  .hub-set__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
  }
  .hub-set__back {
    display: inline-block;
    margin-bottom: 0.45rem;
    font-size: 0.82rem;
    font-weight: 600;
    color: var(--pm-ink-mute);
    text-decoration: none;
  }
  .hub-set__back:hover {
    color: var(--pm-ink);
  }
  .hub-set__title {
    margin: 0.15rem 0 0;
    font-size: clamp(1.55rem, 3.5vw, 2rem);
    font-weight: 700;
    letter-spacing: -0.04em;
    color: var(--pm-ink);
  }
  .hub-set__tools {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    flex-shrink: 0;
  }
  .hub-set__nav {
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;
  }
  .hub-set__nav-item {
    padding: 0.35rem 0.75rem;
    border-radius: 999px;
    font-size: 0.82rem;
    font-weight: 600;
    color: var(--pm-ink-mute);
    border: 1px solid transparent;
  }
  .hub-set__nav-item.is-active {
    color: var(--pm-ink);
    border-color: var(--pm-line);
    background: var(--pm-elevated-bg);
  }
  .hub-set__body {
    flex: 1;
  }
</style>
